import * as ko from "knockout";
ko.bindingHandlers.element = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
        if (ko.isObservable(valueAccessor())) {
            valueAccessor()(element);
        }
    }
};